export default {
  content: null,
  images: [],
  slug: null,
}
